// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorMsg_wrapper__ScI+5","errorBody":"ErrorMsg_errorBody__ew1zJ"};